<!-- Header -->
<app-header></app-header>
<!-- Sidebar -->
<app-sidebar></app-sidebar>

<div class="main-container">
  <!-- Main Content -->
  <main id="main" class="main">
    <!-- app-breadcrumb -->
    <app-breadcrumb></app-breadcrumb>

    <!-- All pages content will render here -->
    <router-outlet></router-outlet>
  </main>
</div>
